export default __webpack_public_path__ + "static/media/play-store.ee4b5fe0.png";